import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';

import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getAllQuestions } from '../../services/requestHandler';

export default function NewQuestionForm(props) {
    const {reponse_id, open, setOpen, onConfirm, title, description } = props;

    let questionInfosConfirm = {
        contenu: "",
        contenu_en: "",
        parent_id: reponse_id,
        enfant_id: null,
    };

  const [questionSelected, setQuestionSelected] = useState("");
  const [questionInfos, setQuestionInfos] = useState(null);

  const [contenu, setContenu] = useState("");
  const [contenu_en, setContenu_en] = useState("");

  const onContentChange = (e) => setContenu(e.target.value);
  const onContent_enChange = (e) => setContenu_en(e.target.value);


async function getQuestions() {
    const infoTemp = await getAllQuestions();
    infoTemp.sort((a, b) => a.contenu.localeCompare(b.contenu))

    const uniqueIds = [];
    const uniqueQuestions = infoTemp.filter(element => {
        const isDuplicate = uniqueIds.includes(element.contenu);
    
        if (!isDuplicate) {
          uniqueIds.push(element.contenu);
    
          return true;
        }
    
        return false;
      });

    //console.log("All questions", uniqueQuestions)
    setQuestionInfos(uniqueQuestions);
}

  React.useEffect(() => {
    getQuestions()
  },[])

//   useEffect(() => {
//   },[questionSelected])

  const handleChange = (event) => {
    const chosenQuestion = questionInfos.find(element => element.id === event.target.value);
    setQuestionSelected((chosenQuestion.id) || '');
    setContenu((chosenQuestion.contenu) || '');
    setContenu_en((chosenQuestion.contenu_en) || '');
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
        setOpen(false);
    }
  };

  return (
    <div>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose} style={{width: "100%"}} >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box  sx={{ display: 'flex', flexWrap: 'wrap' }}>
          <FormControl sx={{ m: 1, width: "100%" }}>
              <InputLabel id="demo-dialog-select-label">{description}</InputLabel>
              <Select
                labelId="demo-dialog-select-label"
                id="demo-dialog-select"
                value={questionSelected}
                onChange={handleChange}
                input={<OutlinedInput label="questionSelected" />}
              >
                <MenuItem value=""><em>None</em></MenuItem>
                {questionInfos !== null && questionInfos.map((questionInfo) => (
                        <MenuItem key={questionInfo.id} value={questionInfo.id}><em>{questionInfo.contenu}</em></MenuItem>
          ))}
              </Select>
            </FormControl>
          </Box>
          <DialogContentText>
           {/* {description} */}
          </DialogContentText>
          <TextField
            autoFocus
            id="content"
            label="Question en francais"
            fullWidth
            type="name"
            variant="standard"
            onChange={onContentChange}
            value={contenu}
          />
          <TextField
            id="content_en"
            label="Question en anglais"
            type="name"
            fullWidth
            variant="standard"
            onChange={onContent_enChange}
            value={contenu_en}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => {
            questionInfosConfirm.contenu = contenu;
            questionInfosConfirm.contenu_en = contenu_en;
            questionInfosConfirm.enfant_id = questionSelected;
            onConfirm(questionInfosConfirm);
            setOpen(false);
        }}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}